import {Action} from "@ngrx/store";
import {
  EditEntitySettingsDto,
  EditPlanDetailRequestDTO,
  MultiEditPlanDetailRequestDTO,
  MultiEditPlanDetailRequestDTOV2
} from "src/app/models/plan";
import {BackgroundTask, TaskState} from "../application-state";

export enum AppActionTypes {
  GetUserInfo = "[App] GET_USER_INFO",
  GetAppInfo = "[App] GET_APP_INFO",
  HasUserInfo = "[App] CHECK_USER_INFO",
  ToggleLoadingState = "[App] TOGGLE_LOADING_STATE",
  SetLoadingState = "[App] SET_LOADING_STATE",
  PerformLogin = "[App] PERFORM_LOGIN",
  LoginFailed = "[App] LOGIN_FAILED",
  ResetLoginState = "[App] RESET_LOGIN_STATE",
  LoginSuccess = "[App] LOGIN_SUCCESS",
  LogInWithAccessCode = "[App] LOG IN WITH ACCESS CODE",

  UpdateLoginState = "[App] UPDATE_LOGIN_STATE",
  PerformLogout = "[App] PERFORM_LOGOUT",
  UpdateUserInfo = "[App] UPDATE_USER_INFO",
  GetEntityList = "[App] GET_ENTITY_LIST",
  EntityListReceived = "[App] RECEIVED_ENTITY_LIST",
  EntityListRequest = "[App] ENTITY LIST REQUEST",
  GetPlanList = "[App] GET_PLAN_LIST",
  PlanListRequest = "[App] PLAN_LIST_REQUEST",
  PlanListReceived = "[App] PLAN_LIST_RECEIVED",
  PlanListRetrieveFailed = "[App] PLAN_LIST_RETRIEVE_FAILED",
  GetPlanDetail = "[App] GET_PLAN_DETAIL",
  LoadPlanDetail = "[App] LOAD_PLAN_DETAIL",
  PlanDetailRequest = "[App] PLAN_DETAIL_REQUEST",
  PlanDetailReceived = "[App] PLAN_DETAIL_RECEIVED",

  SavePlanSettings = "[App] SAVE_PLAN_SETTINGS",
  SavePlanSettingsSuccess = "[App] SAVE_PLAN_SETTINGS_SUCCESS",
  SavePlanSettingsError = "[App] SAVE_PLAN_SETTINGS_ERROR",

  EditPlanDetail = "[App] EDIT_PLAN_DETAIL",
  EditPlanDetailRequest = "[App] EDIT_PLAN_DETAIL_REQUEST",
  EditPlanDetailReceived = "[App] EDIT_PLAN_DETAIL_RECEIVED",

  SavePlanDetail = "[App] SAVE_PLAN_DETAIL",
  SavePlanDetailComplete = "[App] SAVE_PLAN_DETAIL_COMPLETE",

  GetMuStaffing = "[App] GET_MU_STAFFING",
  GetMuStaffingSuccess = "[App] MU_STAFFING_SUCCESS",
  GetMuStaffingFailed = "[App] MU_STAFFING_FAILED",

  RequestSuccessful = "[App] REQUEST_SUCCESSFUL",
  RefreshTokenRequest = "[App] REFRESH_TOKEN_REQUEST",
  RefreshedTokenReceived = "[App] REFRESHED_TOKEN_RECEIVED",
  RefreshedTokenFailure = "[App] REFRESHED_TOKEN_FAILURE",
  ShowToast = "[App] SHOW_TOAST",

  RefreshPlanCache = "[App] REFRESH_PLAN_CACHE",
  RefreshPlanCacheRequest = "[App] REFRESH_PLAN_CACHE_REQUEST",
  RefreshPlanCacheReceived = "[App] REFRESH_PLAN_CACHE_RECEIVED",
  CacheSyncSuccess = "[App] CACHE_SYNC_SUCCESS",
  CacheSyncFailure = "[App]  CACHE_SYNC_FAILURE",

  UpdateMinutesUntilTokenExpiration  = "[App] UPDATE_MINUTES_UNTIL_TOKEN_EXPIRATION",
  UpdateLocale = "[App] UPDATE_LOCALE",
  LocaleUpdated = "[App] LOCALE_UPDATED",

  DeletePlans = "[App] DELETE_PLANS",
  DeletePlansSuccess = "[App] DELETE_PLANS_SUCCESS",
  DeletePlansFailed = "[App] DELETE_PLANS_FAILED",
  PlanNotExist = "[App] PLAN_NOT_EXIST",

  ConvertPlan = "[APP] CONVERT_PLAN",
  ConvertPlanSuccess = "[APP] CONVERT_PLAN_SUCCESS",
  ConvertPlanFailed = "[APP] CONVERT_PLAN_FAILED",

  SaveAsPlan = "[APP] SAVE_AS_PLAN",
  SaveAsPlanReceived = "[APP] SAVE_AS_PLAN_RECEIVED",
  SaveAsPlanSuccess = "[APP] SAVE_AS_PLAN_SUCCESS",
  SaveAsPlanSuccessReceived = "[APP] SAVE_AS_PLAN_SUCCESS_RECEIVED",
  SaveAsPlanFailed = "[APP] SAVE_AS_PLAN_FAILED",

  CheckPlanNameExists = "[APP] CHECK_PLAN_NAME_EXISTS",
  CheckPlanNameExistsReceived = "[APP] CHECK_PLAN_NAME_EXISTS_RECEIVED",
  CheckPlanNameExistsFailed = "[APP] CHECK_PLAN_NAME_EXISTS_FAILED",

  ImportForecastTemplate = "[App] IMPORT_FORECASTS_TEMPLATE",
  ImportForecastTemplateSuccess = "[App] IMPORT_FORECASTS_TEMPLATE_SUCCESS",
  ImportForecastTemplateFailed = "[App] IMPORT_FORECASTS_TEMPLATE_FAILED",

  ImportForecastUploadFile = "[App] IMPORT_FORECASTS_UPLOAD_FILE",
  ImportForecastUploadFileSuccess = "[App] IMPORT_FORECASTS_UPLOAD_FILE_SUCCESS",
  ImportForecastUploadFileProgress = "[App] IMPORT_FORECASTS_UPLOAD_FILE_PROGRESS",
  ImportForecastUploadFileFailed = "[App] IMPORT_FORECASTS_UPLOAD_FILE_FAILED",
  CheckImportForecastFileExists = "[App] CHECK_IMPORT_FORECASTS_FILE_EXISTS",
  CheckImportForecastFileExistsSuccess = "[App] CHECK_IMPORT_FORECASTS_FILE_EXISTS_SUCCESS",
  CheckImportForecastFileExistsFailed = "[App] CHECK_IMPORT_FORECASTS_FILE_EXISTS_FAILED",

  ImportForecastViewLog = "[App] IMPORT_FORECASTS_VIEW_LOG",
  ImportForecastViewLogSuccess = "[App] IMPORT_FORECASTS_VIEW_LOG_SUCCESS",
  ImportForecastViewLogFailed = "[App] IMPORT_FORECASTS_VIEW_LOG_FAILED",

  GetImportForecastsList = "[App] IMPORT_FORECASTS_LIST",
  ImportForecastsListRequest = "[App] IMPORT_FORECASTS_LIST_REQUEST",
  ImportForecastsListReceived = "[App] IMPORT_FORECASTS_LIST_RECEIVED",
  ImportForecastsListRetrieveFailed = "[App] IMPORT_FORECASTS_LIST_RETRIEVE_FAILED",

  NoAction = "[App] NO_ACTION",

  LTFRetrieveFail = "[App]  RETRIEVE_LTF_FAILED",
  UnrecoverableError = "[App] UNRECOVERABLE_ERROR",

  EditNewHireTrainingError = "[App] EDIT_NEW_HIRE_TRAINING_ERROR",
  EditPlanDetailError = "[App] EDIT_PLAN_DETAIL_ERROR",

  SortingCleared = "[App] SORTING_CLEARED",

  GetMUsMUSets = "[App] GET_MUS_MUSETS",
  MuAndMusetReceived = "[App] MU_MUSET_RECEIVED",
  MuAndMusetRetrieveError = "[APP] MU_MUSET_RETRIEVE_ERROR",

  CreatePlan = "[App] CREATE_PLAN",
  CreatePlanSubmitted = "[App]  CREATE_PLAN_SUCCESS",
  CreatePlanError = "[App] CREATE_PLAN_ERROR",

  EditMUDistV2 = "[App] EDIT_MU_DISTRIBUTION_V2",
  EditMUDistSuccess = "[App] EDIT_MU_DISTRIBUTION_SUCCESS",
  EditMUDistError = "[App] EDIT_MU_DISTRIBUTION_ERROR",

  TaskCreateAction = "[APP] TASK_CREATE",
  TaskStartAction = "[APP] TASK_START",
  TaskStatusAction = "[APP] TASK_STATUS",
  TaskErrorAction = "[APP] TASK_ERROR",
  TaskCompleteAction = "[APP] TASK_COMPLETE",
  TaskCancelAction = "[APP] TASK_CANCEL",

  DiscardMUDist = "[App] DISCARD_MU_DISTRIBUTION",
  DiscardMUDistSuccess = "[App] DISCARD_MU_DISTRIBUTION_SUCCESS",
  DiscardMUDistError = "[App] DISCARD_MU_DISTRIBUTION_ERROR",

  ApplyStaffingData = "[App] APPLY_STAFFING_DATA",
  ApplyStaffingDataSuccess = "[App] APPLY_STAFFING_DATA_SUCCESS",
  ApplyStaffingDataError = "[App] APPLY_STAFFING_DATA_ERROR",

  ApplyMuParams = "[App] APPLY_MU_PARAMS",
  ApplyMuParamsSuccess = "[App] APPLY_MU_PARAMS_SUCCESS",
  ApplyMuParamsError = "[App] APPLY_MU_PARAMS_ERROR",

  DeleteImportedForecasts = "[App] DELETE_IMPORTED_FORECASTS",
  DeleteForecastsSuccess = "[App] DELETE_FORECASTS_SUCCESS",
  DeleteForecastsFailed = "[App] DELETE_FORECASTS_FAILED",

  ApplyFTERequired = "[App] APPLY_FTE_REQUIRED",
  ApplyFTERequiredSuccess = "[App] APPLY_FTE_REQUIRED_SUCCESS",
  ApplyFTERequiredError = "[App] APPLY_FTE_REQUIRED_ERROR",

  EditEntitySettings = "[App] EDIT_ENTITY_SETTINGS",
  EditEntitySettingsSuccess = "[App] EDIT_ENTITY_SETTINGS_SUCCESS",
  EditEntitySettingsError = "[App] EDIT_ENTITY_SETTINGS_ERROR",

  GetHistoricalDataCTs = "[App] GET_HISTORICAL_DATA_CTS",
  GetHistoricalDataCTsSuccess = "[App] GET_HISTORICAL_DATA_CTS_SUCCESS",
  GetHistoricalDataCTsFailed = "[App] GET_HISTORICAL_DATA_CTS_FAILED",

  GetHistoricalData = "[App] GET_HISTORICAL_DATA",
  GetHistoricalDataSuccess = "[App] GET_HISTORICAL_DATA_SUCCESS",
  GetHistoricalDataFailed = "[App] GET_HISTORICAL_DATA_FAILED",

  EditHistoricalData = "[App] EDIT_HISTORICAL_DATA",
  EditHistoricalDataSuccess = "[App] EDIT_HISTORICAL_DATA_SUCCESS",
  EditHistoricalDataFailed = "[App] EDIT_HISTORICAL_DATA_FAILED",

  SaveHistoricalData = "[App] SAVE_HISTORICAL_DATA",
  SaveHistoricalDataSuccess = "[App] SAVE_HISTORICAL_DATA_SUCCESS",
  SaveHistoricalDataFailed = "[App] SAVE_HISTORICAL_DATA_FAILED",

  ExportEveryCt = "[App] EXPORT_EVERY_CT",
  ExportEveryCtSuccess = "[App] EXPORT_EVERY_CT_SUCCESS",
  ExportEveryCtFailed = "[App] EXPORT_EVERY_CT_FAILED",

  MultiEditPlanDetail = "[App] MULTI_EDIT_PLAN_DETAIL",
  MultiEditPlanDetailV2 = "[App] MULTI_EDIT_PLAN_DETAIL_V2",
  MultiEditPlanDetailSuccess = "[App] MULTI_EDIT_PLAN_DETAIL_SUCCESS",
  MultiEditPlanDetailFailed = "[App] MULTI_EDIT_PLAN_DETAIL_FAILED",

  GetApiCredential = "[App] GET_API_CREDENTIAL",
  GetApiCredentialSuccess = "[App] GET_API_CREDENTIAL_SUCCESS",
  GetApiCredentialFailed = "[App] GET_API_CREDENTIAL_FAILED",

  GenerateApiCredential = "[App] GENERATE_API_CREDENTIAL",
  GenerateApiCredentialSuccess = "[App] GENERATE_API_CREDENTIAL_SUCCESS",
  GenerateApiCredentialFailed = "[App] GENERATE_API_CREDENTIAL_FAILED",

  DeactivateApiCredential = "[App] DEACTIVATE_API_CREDENTIAL",
  DeactivateApiCredentialSuccess = "[App] DEACTIVATE_API_CREDENTIAL_SUCCESS",
  DeactivateApiCredentialFailed = "[App] DEACTIVATE_API_CREDENTIAL_FAILED",

  GetPlanDetailV2 = "[App] GET_PLAN_DETAIL_V2",
  LoadPlanDetailV2 = "[App] LOAD_PLAN_DETAIL_V2",
  PlanDetailRequestV2 = "[App] PLAN_DETAIL_REQUEST_V2",
  PlanDetailReceivedV2 = "[App] PLAN_DETAIL_RECEIVED_V2",

  GetCTSettings = "[App] GET_CT_SETTINGS",
  GetCTSettingsSuccess = "[App] GET_CT_SETTINGS_SUCCESS",
  GetCTSettingsFailed = "[App] GET_CT_SETTINGS_FAILED",

  ApplyCTSettings = "[App] APPLY_CT_SETTINGS",
  ApplyCTSettingsSuccess = "[App] APPLY_CT_SETTINGS_SUCCESS",
  ApplyCTSettingsFailed = "[App] APPLY_CT_SETTINGS_FAILED",

  UpdateCXoneTenant = "[App] UPDATE_CXONE_TENANT",

  GetLongTermForecasts = "[App] GET_LONG_TERM_FORECASTS",
  GetLongTermForecastsSuccess = "[App] GET_LONG_TERM_FORECASTS_SUCCESS",
  GetLongTermForecastsFailed = "[App] GET_LONG_TERM_FORECASTS_FAILED",

  GetSchedulingUnits = "[App] GET_SCHEDULING_UNITS",
  GetSchedulingUnitsSuccess = "[App] GET_SCHEDULING_UNITS_SUCCESS",
  GetSchedulingUnitsFailed = "[App] GET_SCHEDULING_UNITS_FAILED",

  GetSkillsAndProfiles = "[App] GET_SKILLS_AND_PROFILES",
  GetSkillsAndProfilesSuccess = "[App] GET_SKILLS_AND_PROFILES_SUCCESS",
  GetSkillsAndProfilesFailed = "[App] GET_SKILLS_AND_PROFILES_FAILED",

  CreateCXonePlan = "[App] CREATE_CXONE_PLAN",
  CreateCXonePlanSuccess = "[App] CREATE_CXONE_PLAN_SUCCESS",
  CreateCXonePlanFailed = "[App] CREATE_CXONE_PLAN_FAILED",

  GetNewHireClasses = "[App] GET_NEW_HIRE_CLASSES",
  GetNewHireClassesSuccess = "[App] GET_NEW_HIRE_CLASSES_SUCCESS",
  GetNewHireClassesFailed = "[App] GET_NEW_HIRE_CLASSES_FAILED",

  SaveLearningCurve = "[App] SAVE_LEARNING_CURVE",
  SaveLearningCurveSuccess = "[App] SAVE_LEARNING_CURVE_SUCCESS",
  SaveLearningCurveFailed = "[App] SAVE_LEARNING_CURVE_FAILED",

  DeleteLearningCurve = "[App] DELETE_LEARNING_CURVE",
  DeleteLearningCurveSuccess = "[App] DELETE_LEARNING_CURVE_SUCCESS",
  DeleteLearningCurveFailed = "[App] DELETE_LEARNING_CURVE_FAILED",

  ApplyNewHireClasses = "[App] APPLY_NEW_HIRE_CLASSES",
  ApplyNewHireClassesSuccess = "[App] APPLY_NEW_HIRE_CLASSES_SUCCESS",
  ApplyNewHireClassesFailed = "[App] APPLY_NEW_HIRE_CLASSES_FAILED",

  DiscardNewHireClasses = "[App] DISCARD_NEW_HIRE_CLASSES",
  DiscardNewHireClassesSuccess = "[App] DISCARD_NEW_HIRE_CLASSES_SUCCESS",
  DiscardNewHireClassesFailed = "[App] DISCARD_NEW_HIRE_CLASSES_FAILED"
}

export class GetEntityList implements Action {
  readonly type = AppActionTypes.GetEntityList;

  constructor(public payload: any) {
  }
}

export class EntityListRequest implements Action {
  readonly type = AppActionTypes.EntityListRequest;
  constructor(public payload: any) {
  }
}

export class EntityListReceived implements Action {
  readonly type = AppActionTypes.EntityListReceived;

  constructor(public payload: Array<any>) {
  }
}

export class UpdateLoginState implements Action {
  type = AppActionTypes.UpdateLoginState;
  constructor(public payload: Boolean) {

  }
}

export class UpdateUserInfo implements Action {
  type = AppActionTypes.UpdateUserInfo;
  constructor(public payload: any) {
  }
}

export class PerformLogin implements Action {
  readonly type = AppActionTypes.PerformLogin;

  constructor(public payload: any) {
  }
}

export class SetLoadingState implements Action {
  readonly type = AppActionTypes.SetLoadingState;

  constructor(public payload: boolean = null) {
  }
}

export class ResetLoginState implements Action {
  readonly type = AppActionTypes.ResetLoginState;

  constructor() {
  }
}

export class GetPlanList implements Action {
  readonly type = AppActionTypes.GetPlanList;

  constructor(public payload: any) {
  }
}
export class PlanListRequest implements Action {
  readonly type = AppActionTypes.PlanListRequest;
  constructor(public payload: any) {
  }
}

export class PlanListReceived implements Action {
  readonly type = AppActionTypes.PlanListReceived;

  constructor(public payload: any,public requestPayload:any=null) {
  }
}

export class PlanListRetrieveFailed implements Action {
  readonly type = AppActionTypes.PlanListRetrieveFailed;

  constructor(public payload: any) {
  }
}

export class GetPlanDetail implements Action {
  readonly type = AppActionTypes.GetPlanDetail;

  constructor(public payload: any) {
  }
}

export class LoadPlanDetail implements Action {
  readonly type = AppActionTypes.LoadPlanDetail;

  constructor(public payload: any) {
  }
}

export class PlanDetailRequest implements Action {
  readonly type = AppActionTypes.PlanDetailRequest;
  constructor(public payload: any) {
  }
}

export class PlanDetailReceived implements Action {
  readonly type = AppActionTypes.PlanDetailReceived;

  constructor(public payload: any) {
  }
}


export class EditPlanDetail implements Action {
  readonly type = AppActionTypes.EditPlanDetail;

  constructor(public payload: any) {
  }
}

export class EditPlanDetailRequest implements Action {
  readonly type = AppActionTypes.EditPlanDetailRequest;
  constructor(public payload: EditPlanDetailRequestDTO) {
  }
}

export class EditPlanDetailReceived implements Action {
  readonly type = AppActionTypes.EditPlanDetailReceived;

  constructor(public payload: any) {
  }
}

export class EditPlanDetailError implements Action {
  readonly type = AppActionTypes.EditPlanDetailError;

  constructor(public payload: any) {
  }
}

export class EditNewHireTrainingError implements Action {
  readonly type = AppActionTypes.EditNewHireTrainingError;

  constructor(public payload: any) {
  }
}


export class SavePlanDetail implements Action {
  readonly type = AppActionTypes.SavePlanDetail;

  constructor(public payload: any) {
  }
}

export class SavePlanDetailComplete implements Action {
  readonly type = AppActionTypes.SavePlanDetailComplete;
  constructor(public payload: any) {
  }
}

export class RequestSuccessful implements Action {
  readonly type = AppActionTypes.RequestSuccessful;

  constructor(public payload: any) {}
}

export class RefreshTokenRequest implements Action {
  readonly type = AppActionTypes.RefreshTokenRequest;

  constructor(public payload: any) {
  }
}

export class RefreshedTokenReceived implements Action {
  readonly type = AppActionTypes.RefreshedTokenReceived;

  constructor(public payload: any) {
  }
}

export class RefreshedTokenFailure implements Action {
  readonly type = AppActionTypes.RefreshedTokenFailure;

  constructor(public payload: any) {
  }
}

/** Shows a toast in the app-level p-toast; detail is an i18n key. Survives navigation away from the dispatching page. */
export class ShowToast implements Action {
  readonly type = AppActionTypes.ShowToast;

  constructor(public payload: { severity: "success" | "info" | "warn" | "error"; detail: string }) {
  }
}

export class RefreshPlanCache implements Action {
  readonly type = AppActionTypes.RefreshPlanCache;

  constructor(public payload: any) {
  }
}

export class RefreshPlanCacheRequest implements Action {
  readonly type = AppActionTypes.RefreshPlanCacheRequest;

  constructor(public payload: any) {
  }
}
export class RefreshPlanCacheReceived implements Action {
  readonly type = AppActionTypes.RefreshPlanCacheReceived;

  constructor(public payload: any) {
  }
}

export class CacheSyncSuccess implements Action {
  readonly type = AppActionTypes.CacheSyncSuccess;

  constructor(public payload: any) {
  }
}

export class CacheSyncFailure implements Action {
  readonly type = AppActionTypes.CacheSyncFailure;

  constructor(public payload: any) {
  }
}

export class UpdateMinutesUntilTokenExpiration implements Action {
  readonly type = AppActionTypes.UpdateMinutesUntilTokenExpiration;

  constructor(public payload: any) {
  }
}

export class UpdateLocale implements Action {
  readonly type = AppActionTypes.UpdateLocale;

  constructor(public payload: any) {
  }
}

export class LocaleUpdated implements Action {
  readonly type = AppActionTypes.LocaleUpdated;

  constructor(public payload: any) {
  }
}

export class DeletePlans implements Action {
  readonly type = AppActionTypes.DeletePlans;

  constructor(public payload: any) {
  }
}

export class DeletePlansSuccess implements Action {
  readonly type = AppActionTypes.DeletePlansSuccess;

  constructor(public payload: any) {
  }
}

export class DeletePlansFailed implements Action {
  readonly type = AppActionTypes.DeletePlansFailed;

  constructor(public payload: any) {
  }
}

export class DeleteImportedForecasts implements Action {
  readonly type = AppActionTypes.DeleteImportedForecasts;

  constructor(public payload: any) {
  }
}

export class DeleteForecastsSuccess implements Action {
  readonly type = AppActionTypes.DeleteForecastsSuccess;

  constructor(public payload: any) {
  }
}

export class DeleteForecastsFailed implements Action {
  readonly type = AppActionTypes.DeleteForecastsFailed;

  constructor(public payload: any) {
  }
}

export class PlanNotExist implements Action {
  readonly type = AppActionTypes.PlanNotExist;

  constructor(public payload: any) {
  }
}

export class NoAction implements Action{
  readonly type = AppActionTypes.NoAction;
  constructor(public payload: any){

  }
}

export class ConvertPlan implements Action{
  readonly type = AppActionTypes.ConvertPlan;
  constructor(public payload: any){

  }
}

export class ConvertPlanSuccess implements Action{
  readonly type = AppActionTypes.ConvertPlanSuccess;
  constructor(public payload: any){

  }
}

export class ConvertPlanFailed implements Action{
  readonly type = AppActionTypes.ConvertPlanFailed;
  constructor(public payload: any){

  }
}

export class SaveAsPlan implements Action{
  readonly type = AppActionTypes.SaveAsPlan;
  constructor(public payload: any){

  }
}

export class SaveAsPlanReceived implements Action{
  readonly type = AppActionTypes.SaveAsPlanReceived;
  constructor(public payload: any){

  }
}

export class SaveAsPlanSuccess implements Action{
  readonly type = AppActionTypes.SaveAsPlanSuccess;
  constructor(public payload: any){

  }
}

export class SaveAsPlanSuccessReceived implements Action{
  readonly type = AppActionTypes.SaveAsPlanSuccessReceived;
  constructor(public payload: any){

  }
}

export class SaveAsPlanFailed implements Action{
  readonly type = AppActionTypes.SaveAsPlanFailed;
  constructor(public payload: any){

  }
}

export class CheckPlanNameExists implements Action{
  readonly type = AppActionTypes.CheckPlanNameExists;
  constructor(public payload: any){

  }
}

export class CheckPlanNameExistsReceived implements Action{
  readonly type = AppActionTypes.CheckPlanNameExistsReceived;
  constructor(public payload: any){

  }
}

export class CheckPlanNameExistsFailed implements Action{
  readonly type = AppActionTypes.CheckPlanNameExistsFailed;
  constructor(public payload: any){

  }
}

export class LTFRetrieveFail implements Action{
  readonly type = AppActionTypes.LTFRetrieveFail;
  constructor(public payload: any){

  }
}

export class UnrecoverableError implements Action{
  readonly type = AppActionTypes.UnrecoverableError;
  constructor(public payload: any){
  }
}

export class SortingCleared implements Action{
  readonly type = AppActionTypes.SortingCleared;
  constructor(public payload: any){
  }
}

export class ImportForecastTemplate implements Action{
  readonly type = AppActionTypes.ImportForecastTemplate;
  constructor(public payload: any){

  }
}

export class ImportForecastTemplateSuccess implements Action{
  readonly type = AppActionTypes.ImportForecastTemplateSuccess;
  constructor(public payload: any){

  }
}

export class ImportForecastTemplateFailed implements Action{
  readonly type = AppActionTypes.ImportForecastTemplateFailed;
  constructor(public payload: any){

  }
}

export class CheckImportForecastFileExists implements Action {
  readonly type = AppActionTypes.CheckImportForecastFileExists;
  constructor(public payload: any){
  }
}

export class CheckImportForecastFileExistsSuccess implements Action {
  readonly type = AppActionTypes.CheckImportForecastFileExistsSuccess;
  constructor(public payload: any){
  }
}

export class CheckImportForecastFileExistsFailed implements Action {
  readonly type = AppActionTypes.CheckImportForecastFileExistsFailed;
  constructor(public payload: any){
  }
}

export class ImportForecastUploadFile implements Action {
  readonly type = AppActionTypes.ImportForecastUploadFile;
  constructor(public payload: any){

  }
}

export class ImportForecastUploadFileSuccess implements Action {
  readonly type = AppActionTypes.ImportForecastUploadFileSuccess;
  constructor(public payload: any){

  }
}

export class ImportForecastUploadFileProgress implements Action {
  readonly type = AppActionTypes.ImportForecastUploadFileProgress;
  constructor(public payload: any){

  }
}

export class ImportForecastUploadFileFailed implements Action {
  readonly type = AppActionTypes.ImportForecastUploadFileFailed;
  constructor(public payload: any){

  }
}

export class ImportForecastViewLog implements Action {
  readonly type = AppActionTypes.ImportForecastViewLog;
  constructor(public payload: any){

  }
}

export class ImportForecastViewLogSuccess implements Action {
  readonly type = AppActionTypes.ImportForecastViewLogSuccess;
  constructor(public payload: any){

  }
}

export class ImportForecastViewLogFailed implements Action {
  readonly type = AppActionTypes.ImportForecastViewLogFailed;
  constructor(public payload: any){

  }
}

export class GetMuStaffingFailed implements Action{
  readonly type = AppActionTypes.GetMuStaffingFailed;
  constructor(public payload: any){

  }
}

export class GetMuStaffingSuccess implements Action{
  readonly type = AppActionTypes.GetMuStaffingSuccess;
  constructor(public payload: any){

  }
}


export class GetMuStaffing implements Action{
  readonly type = AppActionTypes.GetMuStaffing;
  constructor(public payload: any){

  }
}

export class GetImportForecastsList implements Action {
  readonly type = AppActionTypes.GetImportForecastsList;
  constructor(public payload: any) {
  }
}
export class ImportForecastsListRequest implements Action {
  readonly type = AppActionTypes.ImportForecastsListRequest;
  constructor(public payload: any) {
  }
}
export class ImportForecastsListReceived implements Action {
  readonly type = AppActionTypes.ImportForecastsListReceived;
  constructor(public payload: any,public requestPayload=null) {
  }
}
export class ImportForecastsListRetrieveFailed implements Action {
  readonly type = AppActionTypes.ImportForecastsListRetrieveFailed;
  constructor(public payload: any) {
  }
}

export class GetMUsMUSets implements Action {
  readonly type = AppActionTypes.GetMUsMUSets;

  constructor(public payload: any) {
  }
}

export class MuAndMusetReceived implements Action {
  readonly type = AppActionTypes.MuAndMusetReceived;

  constructor(public payload: any) {
  }
}

export class MuAndMusetRetrieveError implements Action {
  readonly type = AppActionTypes.MuAndMusetRetrieveError;

  constructor(public payload: any) {
  }
}

export class CreatePlan implements Action {
  readonly type = AppActionTypes.CreatePlan;
  constructor(public payload: any) {

  }
}

export class CreatePlanSubmitted implements Action {
  readonly type = AppActionTypes.CreatePlanSubmitted;

  constructor(public payload: any) {
  }
}

export class CreatePlanError implements Action {
  readonly type = AppActionTypes.CreatePlanError;

  constructor(public payload: any) {
  }
}

export class EditMUDistV2 implements Action {
  readonly type = AppActionTypes.EditMUDistV2;

  constructor(public payload: any) {

  }

}

export class EditMUDistSuccess implements Action {
  readonly type = AppActionTypes.EditMUDistSuccess;

  constructor(public payload: any) {
  }
}

export class EditMUDistError implements Action {
  readonly type = AppActionTypes.EditMUDistError;

  constructor(public payload: any) {
  }
}

export class DiscardMUDist implements Action {
  readonly type = AppActionTypes.DiscardMUDist;

  constructor(public payload: any) {
  }
}

export class DiscardMUDistSuccess implements Action {
  readonly type = AppActionTypes.DiscardMUDistSuccess;

  constructor(public payload: any) {
  }
}

export class DiscardMUDistError implements Action {
  readonly type = AppActionTypes.DiscardMUDistError;

  constructor(public payload: any) {
  }
}


export class TaskCreate implements Action {
  readonly type = AppActionTypes.TaskCreateAction;

  constructor(public payload: BackgroundTask) {

  }
}

export class TaskStart implements Action {
  readonly type = AppActionTypes.TaskStartAction;

  constructor(public payload: BackgroundTask) {

  }
}

export class TaskCancel implements Action {
  readonly type = AppActionTypes.TaskCancelAction;

  constructor(public payload: BackgroundTask) {

  }
}

export class TaskStatus implements Action {
  readonly type = AppActionTypes.TaskStatusAction;

  constructor(public payload: BackgroundTask) {

  }
}

export class TaskError implements Action {
  readonly type = AppActionTypes.TaskErrorAction;

  constructor(public payload: BackgroundTask) {

  }
}

export class TaskComplete implements Action {
  readonly type = AppActionTypes.TaskCompleteAction;

  constructor(public payload: BackgroundTask) {

  }
}


export class ApplyStaffingData implements Action {
  readonly type = AppActionTypes.ApplyStaffingData;

  constructor(public payload: any) {

  }
}
export class ApplyStaffingDataSuccess implements Action {
  readonly type = AppActionTypes.ApplyStaffingDataSuccess;

  constructor(public payload: any) {

  }
}
export class ApplyStaffingDataError implements Action {
  readonly type = AppActionTypes.ApplyStaffingDataError;

  constructor(public payload: any,public taskStatus: TaskState) {

  }
}

export class ApplyMuParams implements Action {
  readonly type = AppActionTypes.ApplyMuParams;

  constructor(public payload: any) {

  }
}

export class ApplyMuParamsSuccess implements Action {
  readonly type = AppActionTypes.ApplyMuParamsSuccess;

  constructor(public payload: any) {

  }
}

export class ApplyMuParamsError implements Action {
  readonly type = AppActionTypes.ApplyMuParamsError;

  constructor(public payload: any, public taskStatus: TaskState) {

  }
}

export class SavePlanSettings implements Action {
  readonly type = AppActionTypes.SavePlanSettings;

  constructor(public payload: any) {
  }
}

export class SavePlanSettingsSuccess implements Action {
  readonly type = AppActionTypes.SavePlanSettingsSuccess;

  constructor(public payload: any) {
  }
}


export class SavePlanSettingsError implements Action {
  readonly type = AppActionTypes.SavePlanSettingsError;

  constructor(public payload: any, public taskStatus: TaskState) {
  }
}


export class ApplyFTERequired implements Action {
  readonly type = AppActionTypes.ApplyFTERequired;

  constructor(public payload: any) {

  }
}

export class ApplyFTERequiredSuccess implements Action {
  readonly type = AppActionTypes.ApplyFTERequiredSuccess;

  constructor(public payload: any) {

  }
}

export class ApplyFTERequiredError implements Action {
  readonly type = AppActionTypes.ApplyFTERequiredError;

  constructor(public payload: any, public taskStatus: TaskState) {

  }
}

export class EditEntitySettings implements Action {
  readonly type = AppActionTypes.EditEntitySettings;
  constructor(public payload: EditEntitySettingsDto) {

  }
}

export class EditEntitySettingsSuccess implements Action {
  readonly type = AppActionTypes.EditEntitySettingsSuccess;
  constructor(public payload: EditEntitySettingsDto) {

  }
}

export class EditEntitySettingsError implements Action {
  readonly type = AppActionTypes.EditEntitySettingsError;
  constructor(public payload: any) {

  }
}
export class GetHistoricalDataCTs implements Action{
  readonly type = AppActionTypes.GetHistoricalDataCTs;
  constructor(){

  }
}

export class GetHistoricalDataCTsSuccess implements Action{
  readonly type = AppActionTypes.GetHistoricalDataCTsSuccess;
  constructor(public payload: any){

  }
}
export class GetHistoricalDataCTsFailed implements Action{
  readonly type = AppActionTypes.GetHistoricalDataCTsFailed;
  constructor(public payload: any){

  }
}

export class GetHistoricalData implements Action{
  readonly type = AppActionTypes.GetHistoricalData;
  constructor(public payload:any,public sessionId:string,public requestId:number){

  }
}

export class GetHistoricalDataSuccess implements Action{
  readonly type = AppActionTypes.GetHistoricalDataSuccess;
  constructor(public payload: any,public requestId:number){

  }
}
export class GetHistoricalDataFailed implements Action{
  readonly type = AppActionTypes.GetHistoricalDataFailed;
  constructor(public payload: any,public requestId:number){

  }
}

export class EditHistoricalData implements Action{
  readonly type = AppActionTypes.EditHistoricalData;
  constructor(public payload:any,public sessionId:string){

  }
}

export class EditHistoricalDataSuccess implements Action{
  readonly type = AppActionTypes.EditHistoricalDataSuccess;
  constructor(public payload: any){

  }
}
export class EditHistoricalDataFailed implements Action{
  readonly type = AppActionTypes.EditHistoricalDataFailed;
  constructor(public payload: any){

  }
}


export class SaveHistoricalData implements Action{
  readonly type = AppActionTypes.SaveHistoricalData;
  constructor(public sessionId:string){

  }
}

export class SaveHistoricalDataSuccess implements Action{
  readonly type = AppActionTypes.SaveHistoricalDataSuccess;
  constructor(public payload: any){

  }
}
export class SaveHistoricalDataFailed implements Action{
  readonly type = AppActionTypes.SaveHistoricalDataFailed;
  constructor(public payload: any){

  }
}

export class ExportEveryCt implements Action {
  readonly type = AppActionTypes.ExportEveryCt;
  constructor(public payload: any) {

  }
}

export class ExportEveryCtSuccess implements Action {
  readonly type = AppActionTypes.ExportEveryCtSuccess;
  constructor(public payload: any) {

  }
}

export class ExportEveryCtFailed implements Action {
  readonly type = AppActionTypes.ExportEveryCtFailed;
  constructor(public payload: any) {

  }
}

export class MultiEditPlanDetail implements Action {
  readonly type = AppActionTypes.MultiEditPlanDetail;
  constructor(public payload: MultiEditPlanDetailRequestDTO) {

  }
}

export class MultiEditPlanDetailSuccess implements Action {
  readonly type = AppActionTypes.MultiEditPlanDetailSuccess;
  constructor(public payload: any) {

  }
}

export class MultiEditPlanDetailFailed implements Action {
  readonly type = AppActionTypes.MultiEditPlanDetailFailed;
  constructor(public payload: any) {

  }
}
export class GetApiCredential implements Action {
  readonly type = AppActionTypes.GetApiCredential;
  constructor(public payload: any) {

  }
}
export class GetApiCredentialSuccess implements Action {
  readonly type = AppActionTypes.GetApiCredentialSuccess;
  constructor(public payload: any) {

  }
}
export class GetApiCredentialFailed implements Action {
  readonly type = AppActionTypes.GetApiCredentialFailed;
  constructor(public payload: any) {

  }
}

export class GenerateApiCredential implements Action {
  readonly type = AppActionTypes.GenerateApiCredential;
  constructor(public payload: any) {

  }
}
export class GenerateApiCredentialSuccess implements Action {
  readonly type = AppActionTypes.GenerateApiCredentialSuccess;
  constructor(public payload: any) {

  }
}
export class GenerateApiCredentialFailed implements Action {
  readonly type = AppActionTypes.GenerateApiCredentialFailed;
  constructor(public payload: any) {

  }
}

export class DeactivateApiCredential implements Action {
  readonly type = AppActionTypes.DeactivateApiCredential;
  constructor(public payload: any) {

  }
}

export class DeactivateApiCredentialSuccess implements Action {
  readonly type = AppActionTypes.DeactivateApiCredentialSuccess;
  constructor(public payload: any) {

  }
}

export class DeactivateApiCredentialFailed implements Action {
  readonly type = AppActionTypes.DeactivateApiCredentialFailed;
  constructor(public payload: any) {

  }
}

export class GetPlanDetailV2 implements Action {
  readonly type = AppActionTypes.GetPlanDetailV2;

  constructor(public payload: any) {
  }
}

export class LoadPlanDetailV2 implements Action {
  readonly type = AppActionTypes.LoadPlanDetailV2;

  constructor(public payload: any) {
  }
}

export class PlanDetailRequestV2 implements Action {
  readonly type = AppActionTypes.PlanDetailRequestV2;
  constructor(public payload: any) {
  }
}

export class PlanDetailReceivedV2 implements Action {
  readonly type = AppActionTypes.PlanDetailReceivedV2;

  constructor(public payload: any) {
  }
}

export class MultiEditPlanDetailV2 implements Action {
  readonly type = AppActionTypes.MultiEditPlanDetailV2;
  constructor(public payload: MultiEditPlanDetailRequestDTOV2) {

  }
}

export class GetCTSettings implements Action {
  readonly type = AppActionTypes.GetCTSettings;
  constructor(public payload: any) {
  }
}

export class GetCTSettingsSuccess implements Action {
  readonly type = AppActionTypes.GetCTSettingsSuccess;
  constructor(public payload: any) {
  }
}

export class GetCTSettingsFailed implements Action {
  readonly type = AppActionTypes.GetCTSettingsFailed;
  constructor(public payload: any) {
  }
}

export class ApplyCTSettings implements Action {
  readonly type = AppActionTypes.ApplyCTSettings;
  constructor(public payload: any) {
  }
}

export class ApplyCTSettingsSuccess implements Action {
  readonly type = AppActionTypes.ApplyCTSettingsSuccess;
  constructor(public payload: any) {
  }
}

export class ApplyCTSettingsFailed implements Action {
  readonly type = AppActionTypes.ApplyCTSettingsFailed;
  constructor(public payload: any) {
  }
}

export class UpdateCXoneTenant implements Action {
  readonly type = AppActionTypes.UpdateCXoneTenant;
  constructor(public payload: boolean) {

  }
}

export class GetLongTermForecasts implements Action {
  readonly type = AppActionTypes.GetLongTermForecasts;
  constructor(public payload: any) {
  }
}

export class GetLongTermForecastsSuccess implements Action {
  readonly type = AppActionTypes.GetLongTermForecastsSuccess;
  constructor(public payload: any) {
  }
}

export class GetLongTermForecastsFailed implements Action {
  readonly type = AppActionTypes.GetLongTermForecastsFailed;
  constructor(public payload: any) {
  }
}

export class GetSchedulingUnits implements Action {
  readonly type = AppActionTypes.GetSchedulingUnits;
  constructor(public payload: any) {
  }
}

export class GetSchedulingUnitsSuccess implements Action {
  readonly type = AppActionTypes.GetSchedulingUnitsSuccess;
  constructor(public payload: any) {
  }
}

export class GetSchedulingUnitsFailed implements Action {
  readonly type = AppActionTypes.GetSchedulingUnitsFailed;
  constructor(public payload: any) {
  }
}

export class GetSkillsAndProfiles implements Action {
  readonly type = AppActionTypes.GetSkillsAndProfiles;
  constructor(public payload: any) {
  }
}

export class GetSkillsAndProfilesSuccess implements Action {
  readonly type = AppActionTypes.GetSkillsAndProfilesSuccess;
  constructor(public payload: any) {
  }
}

export class GetSkillsAndProfilesFailed implements Action {
  readonly type = AppActionTypes.GetSkillsAndProfilesFailed;
  constructor(public payload: any) {
  }
}

export class CreateCXonePlan implements Action {
  readonly type = AppActionTypes.CreateCXonePlan;
  constructor(public payload: any) {
  }
}

export class CreateCXonePlanSuccess implements Action {
  readonly type = AppActionTypes.CreateCXonePlanSuccess;
  constructor(public payload: any) {
  }
}

export class CreateCXonePlanFailed implements Action {
  readonly type = AppActionTypes.CreateCXonePlanFailed;
  constructor(public payload: any) {
  }
}

export class GetNewHireClasses implements Action {
  readonly type = AppActionTypes.GetNewHireClasses;
  constructor(public payload: any) {
  }
}

export class GetNewHireClassesSuccess implements Action {
  readonly type = AppActionTypes.GetNewHireClassesSuccess;
  constructor(public payload: any) {
  }
}

export class GetNewHireClassesFailed implements Action {
  readonly type = AppActionTypes.GetNewHireClassesFailed;
  constructor(public payload: any) {
  }
}

export class SaveLearningCurve implements Action {
  readonly type = AppActionTypes.SaveLearningCurve;
  constructor(public payload: any) {
  }
}

export class SaveLearningCurveSuccess implements Action {
  readonly type = AppActionTypes.SaveLearningCurveSuccess;
  constructor(public payload: any) {
  }
}

export class SaveLearningCurveFailed implements Action {
  readonly type = AppActionTypes.SaveLearningCurveFailed;
  constructor(public payload: any) {
  }
}
export class ApplyNewHireClasses implements Action {
  readonly type = AppActionTypes.ApplyNewHireClasses;
  constructor(public payload: any) {
  }
}
export class ApplyNewHireClassesSuccess implements Action {
  readonly type = AppActionTypes.ApplyNewHireClassesSuccess;
  constructor(public payload: any) {
  }
}
export class ApplyNewHireClassesFailed implements Action {
  readonly type = AppActionTypes.ApplyNewHireClassesFailed;
  constructor(public payload: any) {
  }
}

export class DiscardNewHireClasses implements Action {
  readonly type = AppActionTypes.DiscardNewHireClasses;
  constructor(public payload: any) {
  }
}

export class DiscardNewHireClassesSuccess implements Action {
  readonly type = AppActionTypes.DiscardNewHireClassesSuccess;
  constructor(public payload: any) {
  }
}

export class DiscardNewHireClassesFailed implements Action {
  readonly type = AppActionTypes.DiscardNewHireClassesFailed;
  constructor(public payload: any) {
  }
}

export class DeleteLearningCurve implements Action {
  readonly type = AppActionTypes.DeleteLearningCurve;
  constructor(public payload: any) {
  }
}

export class DeleteLearningCurveSuccess implements Action {
  readonly type = AppActionTypes.DeleteLearningCurveSuccess;
  constructor(public payload: any) {
  }
}

export class DeleteLearningCurveFailed implements Action {
  readonly type = AppActionTypes.DeleteLearningCurveFailed;
  constructor(public payload: any) {
  }
}

export type AppAction = PlanNotExist |SavePlanDetail | SavePlanDetailComplete | EditPlanDetail | EditPlanDetailReceived
  | GetPlanDetail | PlanDetailReceived | GetPlanList | PlanListReceived | UpdateLoginState | UpdateUserInfo
  | GetEntityList | RequestSuccessful | RefreshTokenRequest | RefreshedTokenReceived | UpdateMinutesUntilTokenExpiration
  | UpdateLocale | LocaleUpdated | DeletePlans | DeletePlansSuccess | DeletePlansFailed | RefreshPlanCache
  | RefreshPlanCacheRequest | ConvertPlan | ConvertPlanSuccess | ConvertPlanFailed | SaveAsPlan | SaveAsPlanReceived
  | SaveAsPlanSuccess | SaveAsPlanSuccessReceived | SaveAsPlanFailed | CheckPlanNameExists | CheckPlanNameExistsReceived
  | CheckPlanNameExistsFailed
  | LTFRetrieveFail | UnrecoverableError | EditNewHireTrainingError | PlanListRetrieveFailed | SortingCleared
  | ImportForecastUploadFile | ImportForecastUploadFileSuccess | ImportForecastUploadFileProgress | ImportForecastUploadFileFailed
  | CheckImportForecastFileExists | CheckImportForecastFileExistsSuccess | CheckImportForecastFileExistsFailed
  | GetImportForecastsList | ImportForecastsListRequest | ImportForecastsListReceived | ImportForecastsListRetrieveFailed
  | GetMuStaffing | GetMuStaffingSuccess | GetMuStaffingFailed
  | ImportForecastTemplate | ImportForecastTemplateSuccess | ImportForecastTemplateFailed | GetMUsMUSets | MuAndMusetReceived
  | MuAndMusetRetrieveError
  | ImportForecastViewLog | ImportForecastViewLogSuccess | ImportForecastViewLogFailed
  | CreatePlan | CreatePlanSubmitted | CreatePlanError
  | EditMUDistSuccess | EditMUDistError
  | DiscardMUDist | DiscardMUDistSuccess | DiscardMUDistError
  | ApplyMuParams | ApplyMuParamsSuccess | ApplyMuParamsError
  | DeleteImportedForecasts | DeleteForecastsSuccess | DeleteForecastsFailed
  | SavePlanSettings | SavePlanSettingsSuccess | SavePlanSettingsError
  | ApplyFTERequired | ApplyFTERequiredSuccess | ApplyFTERequiredError
  | EditEntitySettings | EditEntitySettingsSuccess | EditEntitySettingsError | EditMUDistV2
  | GetHistoricalDataCTs | GetHistoricalDataCTsSuccess | GetHistoricalDataCTsFailed
  | GetHistoricalData | GetHistoricalDataSuccess | GetHistoricalDataFailed
  | SaveHistoricalData | SaveHistoricalDataSuccess | SaveHistoricalDataFailed
  | ExportEveryCt | ExportEveryCtSuccess | ExportEveryCtFailed
  | GetApiCredential | GetApiCredentialSuccess |GetApiCredentialFailed
  | GenerateApiCredential | GenerateApiCredentialSuccess |GenerateApiCredentialFailed
  | DeactivateApiCredential | DeactivateApiCredentialSuccess | DeactivateApiCredentialFailed
  | GetCTSettings | GetCTSettingsSuccess | GetCTSettingsFailed | ApplyCTSettings | ApplyCTSettingsSuccess | ApplyCTSettingsFailed
  | GetLongTermForecasts | GetLongTermForecastsSuccess | GetLongTermForecastsFailed
  | GetSchedulingUnits | GetSchedulingUnitsSuccess | GetSchedulingUnitsFailed
  | GetSkillsAndProfiles | GetSkillsAndProfilesSuccess | GetSkillsAndProfilesFailed
  | CreateCXonePlan | CreateCXonePlanSuccess | CreateCXonePlanFailed
  | GetNewHireClasses | GetNewHireClassesSuccess | GetNewHireClassesFailed
  | SaveLearningCurve | SaveLearningCurveSuccess | SaveLearningCurveFailed
  | ApplyNewHireClasses | ApplyNewHireClassesSuccess | ApplyNewHireClassesFailed
  | DiscardNewHireClasses | DiscardNewHireClassesSuccess | DiscardNewHireClassesFailed
  | DeleteLearningCurve | DeleteLearningCurveSuccess | DeleteLearningCurveFailed
  | ShowToast
